import {
  ALL_RELEASES_QUERY,
  LATEST_RELEASE_QUERY,
} from '@src/gql/releases-gql';

import type { GraphQLClient } from 'graphql-request';

export interface ReleaseVideo {
  id: string;
  title: string;
  videoFilePrimary: {
    url: string;
    video: {
      thumbnailUrl: string;
      muxPlaybackId: string;
      mp4Url: string;
    } | null;
  } | null;
}

export interface ReleaseImage {
  url: string;
  width: number;
  height: number;
  title: string;
}

export interface DatoRelease {
  id: string;
  releaseName: string;
  description: string;
  video: ReleaseVideo | null;
  image: ReleaseImage | null;
  _createdAt: string;
}

interface AllReleasesResponse {
  allReleasesModels: DatoRelease[];
  _allReleasesModelsMeta: { count: number };
}

interface LatestReleaseResponse {
  allReleasesModels: DatoRelease[];
}

export class ReleasesRepository {
  private gqlClient: GraphQLClient;

  constructor(gqlClient: GraphQLClient) {
    this.gqlClient = gqlClient;
  }

  async fetchReleases(
    skip: number = 0,
    first: number = 10,
  ): Promise<{ releases: DatoRelease[]; totalCount: number }> {
    const response = await this.gqlClient.request<AllReleasesResponse>(
      ALL_RELEASES_QUERY,
      { first, skip },
    );
    return {
      releases: response.allReleasesModels,
      totalCount: response._allReleasesModelsMeta.count,
    };
  }

  async fetchLatestRelease(): Promise<DatoRelease | null> {
    const response =
      await this.gqlClient.request<LatestReleaseResponse>(LATEST_RELEASE_QUERY);
    return response.allReleasesModels[0] ?? null;
  }
}
